import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import _ from "lodash";
import moment from "moment";
//actions
import { actions } from "actions/resources";
import { searchClients, searchCompanies } from "actions/search";
//antd
import { Button, Col, Input, Table, Row, Typography } from "antd";
import ClientsCarousel from "./carousel";
import { clientsIndex, companiesIndex } from "../../../utils/algolia";

export class Companies extends Component {
  state = {
    selectedCompany: null,
    selectedCompanyInfo: null,
    addEditFormVisible: false,
    infoFormVisible: false,
    clientsAlgolia: []
  };

  componentWillMount() {
    clientsIndex.clearCache();
    companiesIndex.clearCache();
    this._fetchDependencies();
  }

  _fetchDependencies = async () => {
    console.log("fetching dependencies");

    const { searchClients, searchCompanies, fetchClients, } = this.props;
    await searchClients();
    await searchCompanies();
    await fetchClients({ status: "on-boarding" });
  };

  _onSearchInput = e => {
    const { searchClients, searchCompanies } = this.props;
    searchClients(e.target.value);
    searchCompanies(e.target.value);
  };

  _compareCompanyId = (companyObj, clientObj) => {
    return clientObj.company_id === companyObj.id
  };

  render() {
    const { clientsAlgolia, companiesAlgolia, redirect, newClients } = this.props;
    const Search = Input.Search;
    const { Title } = Typography;

    const clientsColumns = [

      {
        width: 300,
        title: "User",
        dataIndex: "first_name",
        key: "client_name",
        sorter: (a, b) => {
          return a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase());
        },
        render: (text, record) => {
          return (
            <div>
              {record.first_name !== "_" ?
                <Link to={`/companies/client/edit/${record.objectID}`}>{record.first_name + " " + record.last_name}</Link>
                : <span>{record.first_name + " " + record.last_name}</span>
              }

            </div>
          );
        }
      },
      {
        width: 300,
        title: "Company Name",
        dataIndex: "name",
        key: "company_name",
        sorter: (a, b) => {
          return a.company_name.toLowerCase().localeCompare(b.company_name.toLowerCase());
        },
        render: (text, record) => {
          return (
            <div>
              <Link to={`/companies/edit/${record.company_id}`}>{record.company_name}</Link>
            </div>
          );
        }
      },
      {
        width: 200,
        title: "Status",
        align: "center",
        dataIndex: "status",
        key: "status",
        sorter: (a, b) => {
          return a.status.toLowerCase().localeCompare(b.status.toLowerCase());
        },
        render: (text, record, e) => {
          return (
            <div>
              <span>
                {record.status}
              </span>
            </div>
          );
        }
      },
      {
        width: 100,
        title: "Date",
        key: "created_at",
        align: "center",
        render: (a) => { return moment(a.created_at).format("M/D/YYYY"); }
      }
    ];

    if (clientsAlgolia.hits && companiesAlgolia.hits) {

      // console.log(companiesAlgolia.hits);
      // console.log(clientsAlgolia.hits);


      const companiesNoClient = _.differenceWith(companiesAlgolia.hits, clientsAlgolia.hits, this._compareCompanyId);

      const companiesNoClientCleaned = companiesNoClient.filter(company => company.name != "error").map(company => ({
        first_name: " ",
        last_name: " ",
        company_name: company.name,
        company_id: company.id,
        ...company
      }));

      let cleanCompaniesClientsList = _.concat(clientsAlgolia.hits, companiesNoClientCleaned);

      cleanCompaniesClientsList = cleanCompaniesClientsList.map((company, index) => ({
        id: index,
        ...company
      }));

      return (
        <div className="detail-spacer">
          <Row type="flex" align="middle">
            <Col span={18}>
              <h1 id="header">Companies Dashboard</h1>
            </Col>
            <Col span={6}>
              <Row type="flex" justify="end">
                <Link to="/companies/new">
                  <Button type="primary" htmlType="submit">
                    Add Company
                  </Button>
                </Link>
              </Row>
            </Col>
          </Row>
          <Row>
            {newClients.length ?
              <Row>
                <Title level={4}>New Company Users</Title>
              </Row> : null}
            <ClientsCarousel
              items={newClients}
              redirect={redirect}
            />
          </Row>
          <Row>
            <Title level={4}>All Company Users</Title>
            <Col type="flex" justify="center" align="middle">
              <Search
                placeholder="Search for users, companies or status"
                onChange={this._onSearchInput}
              />
            </Col>
          </Row>
          <br />
          <Row justify="center" align="middle">
            <Table
              columns={clientsColumns}
              dataSource={cleanCompaniesClientsList}
              rowKey="id"
              size="small"
              scroll={{ x: 600 }}
            />
          </Row>
        </div>
      );
    }
    return null;
  }
}

export default connect(
  state => ({
    challenges: state.resources.collection.challenge || [],
    clientsAlgolia: state.search.clientsAlgolia,
    companiesAlgolia: state.search.companiesAlgolia,
    newClients: state.resources.collection.client || []
  }),
  dispatch => ({
    fetchClients: bindActionCreators(actions.fetchClients, dispatch),
    redirect: bindActionCreators(push, dispatch),
    searchClients: bindActionCreators(searchClients, dispatch),
    searchCompanies: bindActionCreators(searchCompanies, dispatch)
  })
)(Companies);



// WEBPACK FOOTER //
// ./src/components/dashboard/company/index.js